export default "__VITE_ASSET__965be292__"